import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  MessageReactionsLoadAction,
  MessageReactionsLoadFulfilledAction,
  MessageReactionsLoadPendingAction,
} from '../../domains/messageReactions/actions.types';
import { Message } from '../messages/types';

import { MessageReactions, MessagesReactions } from './types';

export type { MessageReactionsLoadAction };

const initialState: MessagesReactions = {};

const initialMessageReactions: MessageReactions = {
  userIds: [],
  reactions: {},
  cursor: null,
  hasNextPage: false,
  status: 'notRequested',
};

const stateWithPendingLikes = (
  state: MessagesReactions,
  { id, isInitialLoad }: MessageReactionsLoadPendingAction['payload']
): MessagesReactions => {
  const messageReactions = isInitialLoad ? initialMessageReactions : state[id];

  return addToRecord(state, id, { ...messageReactions, status: 'pending' });
};

const stateWithFulfilledLikes = (
  state: MessagesReactions,
  { id, entities, isInitialLoad }: MessageReactionsLoadFulfilledAction['payload']
): MessagesReactions => {
  const { cursor, hasNextPage, userIds: newUserIds, reactions: newReactions } = entities.messageReactions[id];
  const userIds = isInitialLoad ? newUserIds : [...state[id].userIds, ...newUserIds];
  const reactions = isInitialLoad ? newReactions : { ...state[id].reactions, ...newReactions };

  const fulfilledMessageReactions: MessageReactions = {
    userIds: [...new Set(userIds)],
    reactions,
    cursor,
    hasNextPage,
    status: 'fulfilled',
  };

  return addToRecord(state, id, fulfilledMessageReactions);
};

const stateWithRejectedLikes = (state: MessagesReactions, id: Message['id']): MessagesReactions =>
  updateRecord(state, id, { status: 'rejected' });

const reducer: Reducer<MessagesReactions, MessageReactionsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MESSAGE_REACTIONS.LOAD_PENDING': {
      return stateWithPendingLikes(state, action.payload);
    }
    case 'MESSAGE_REACTIONS.LOAD_FULFILLED': {
      return stateWithFulfilledLikes(state, action.payload);
    }
    case 'MESSAGE_REACTIONS.LOAD_REJECTED': {
      return stateWithRejectedLikes(state, action.payload.id);
    }
    default:
      return state;
  }
};

export default reducer;
